// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__9Bk28","content":"LoadingAlert_content__6cRNn"};